import React from 'react';

import {Modal, message} from 'antd';

import moment from 'moment';

import fetch from './fetch';
import utils from './../utils';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'name', label: '文件名称'},
    {key:'fullPath', label: '文件路径'},
    {key:'fileNumber', label: '文件字号'},
    {key:'publishOrgName', label: '发文部门'},
    {key:'publishDate', label: '发布日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'realName', label: '上传人'},
    {type:'action', label: '操作', width: 120, values: ['read','video','image', 'down', 'file']},
]);
/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('file/manage/attachment/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'folder/auth/'+ url;
};

export default {
    querySearch,
    headers,
    onSelect,
    setRefresh,
    redirect
}